import { DocumentNode } from "@apollo/client";
import { TranslationKey } from "providers/I18nProvider";
import { ComponentType, ReactNode } from "react";
import { Operation } from "types";

export enum FieldType {
  String = "String",
  Uuid = "Uuid",
  Email = "Email",
  DateTime = "DateTime",
  Duration = "Duration",
  Enum = "Enum",
  JSON = "JSON",
  User = "User",
  Company = "Company",
  Boolean = "Boolean",
}

export type FieldConfig = {
  key: string;
  labelKey: TranslationKey;
  type: FieldType;
  width: number | { min?: number; max?: number; grow?: number };
  enumValues?: Record<string, { label: string; color?: string }>;
  format?: (value: unknown, item: unknown) => ReactNode;
  sortKey?: string;
};

export type InternalResourceConfig = {
  resourceName: string;
  displayNameKey: TranslationKey;
  basePath: string;

  listQuery: DocumentNode;
  listQueryName: string;

  fields: FieldConfig[];

  list: {
    defaultSort: { column: string; direction: "asc" | "desc" };
    searchFields: Array<string | { field: string; op: Operation }>;
  };

  details?: {
    component: ComponentType<{ selectedId: string; onClose: () => void }>;
    paramKey?: string;
  };

  navigation: {
    icon: ReactNode;
    order: number;
  };
};
